import script from "./FAQView.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQView.vue?vue&type=script&setup=true&lang=js"

import "./FAQView.vue?vue&type=style&index=0&id=07565ed2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07565ed2"]])

export default __exports__